import api from './apiClient';

export const raceTypesAPI = {
  getRaceTypes: async (raceId) => {
    const response = await api.get(`/api/races/${raceId}/racetypes`);
    return response.data;
  },
  createRaceType: async (raceId, raceTypeData) => {
    const response = await api.post(`/api/races/${raceId}/racetypes`, raceTypeData);
    return response.data;
  },
  updateRaceType: async (id, raceTypeData) => {
    const response = await api.post(`/api/racetypes/${id}`, raceTypeData);
    return response.data;
  },
  deleteRaceType: async (id) => {
    await api.post(`/api/racetypes/${id}/delete`, {});
  },
};
